var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"copy-btn",on:{"click":function($event){return _vm.$emit('copy')}}},[(_vm.copied)?_c('span',[_vm._v("Copied!")]):_c('span',[_vm._v("Copy")])])
}
var staticRenderFns = []

export { render, staticRenderFns }